const Footer = {
  init() {
    Footer.events();

    requestAnimationFrame(Footer.animate);
  },
  events() {
    $(".btn-scroll-top").on("click", () => {
      $("html, body").animate({ scrollTop: 0 }, 600);
    });
  },

  animate() {
    document.querySelectorAll(".footer-visual path").forEach((path) => {
      path.style.opacity = Footer.getRandomNumber().toString();
    });

    setTimeout(() => {
      requestAnimationFrame(Footer.animate);
    }, 900);
  },

  getRandomNumber() {
    // Generate a random number between 0 and 5 (inclusive)
    const randomNumber = Math.floor(Math.random() * 6);
    // Convert the random number to a value between 0.5 and 1
    const result = 0.5 + randomNumber * 0.1;
    return result;
  },
};

export default Footer;
